export default {
  "platform":"雨量统计平台",
  "userName": "请输入邮箱",
  "password": "请输入密码",
  "login": "登录",
  "logout": "退出",
  "userError":"电子邮箱不能为空",
  "passwordError": "密码不能为空",
  "loginError":"用户名或密码不正确，请重新登录",
  "deviceError":"当前设备不存在雨量",
  "deviceDisconnect":"当前设备雨量已掉线",
  "deviceCount":"设备统计",
  "totalDevice": "总设备",
  "offDevice": "离线设备",
  "onDevice": "运行设备",
  "realTime":"实时雨量",
  "minuteRainfall":"分钟雨量",
  "instantRainfall":"瞬时雨量",
  "oneMinute":"1分钟雨量",
  "fiveMinute":"5分钟雨量",
  "tenMinute":"10分钟雨量",
  "hourRainfall":"小时雨量",
  "currentPeriod":"当前时段雨量",
  "previousPeriod":"上一时段雨量",
  "deviceMap": "设备地图",
  "dayRainfall": "日降雨",
  "dataUpdate":"数据更新",
  "close":"关闭",
  "cumulativeRainfall":"日累计雨量",
  "dailyRainfall":"日雨量",
  "boundary":"请输入日分界时",
  "cordon":"请输入雨量警戒值",
  "submit":"提交",
  "rainstorm":"暴雨",
  "heavyRain":"大雨",
  "moderateRain":"中雨",
  "lightRain":"小雨",
  "noRain":"无雨",
  "boundaryWarn":"数值在 0-23 之间，请重新输入",
  "boundarySuccess":"雨量分界值设置成功",
  "boundaryError":"雨量分界值设置失败，请重新上传",
  "cordonWarn":"请输入正确的数值",
  "cordonSuccess":"雨量警戒值设置成功",
  "cordonError":"雨量境界值设置失败，请重新上传",
  "statistical":"统计雨量",
  "five":"5分钟",
  "ten":"10分钟",
  "hour":"小时",
  "day":"日",
  "month":"月",
  "sum":"累计",
  "export":"导出",
  "fiveMinuteRainfall":"五分钟雨量",
  "tenMinuteRainfall":"十分钟雨量",
  "oneHourRainfall":"一小时雨量",
  "dayRain":"日雨量",
  "monthRain":"月雨量",
  "time":"时间",
  "value":"数值",
  "noData":"没有符合条件的数据",
  "dataList":"统计",
  "mobileReal":"实时雨量",
  "mobileStatistical":"统计雨量",
  "mobileRealTime":"实时",
  "mobileStatisticalRain":"统计",
  "mobileDeviceError":"当前设备不存在雨量",
  "mobileInstantRainfall":"瞬时雨量",
  "mobileOneMinute":"1分钟雨量",
  "mobileFiveMinute":"5分钟雨量",
  "mobileFenMinute":"10分钟雨量",
  "mobileCurrentPeriod":"当前时段雨量",
  "mobilePreviousPeriod":"上一时段雨量",
  "mobileDailyRainfall":"日雨量",
  "mobileDeviceDisconnect":"当前设备雨量已掉线",
  "mobileDaily":"日分界时",
  "mobileLine":"雨量警戒线",
  "mobileSubmit":"提交",
  "mobileRainstorm":"暴雨",
  "mobileHeavyRain":"大雨",
  "mobileModerateRain":"中雨",
  "mobileLightRain":"小雨",
  "mobileNoRain":"无雨",
  "mobileBoundaryWarn":"数值在 0-23 之间，请重新输入",
  "mobileBoundarySuccess":"雨量分界值设置成功",
  "mobileBoundaryError":"雨量分界值设置失败，请重新上传",
  "mobileCordonWarn":"请输入正确的数值",
  "mobileCordonSuccess":"雨量警戒值设置成功",
  "mobileCordonError":"雨量境界值设置失败，请重新上传",
  "mobileTimePeriod":"请选择时间段",
  "mobileExport":"导出",
  "mobileFive":"五分钟",
  "mobileTen":"十分钟",
  "mobileHour":"时",
  "mobileDay":"日",
  "mobileMonth":"月",
  "mobileSum":"累计",
  "mobileFiveMinuteRainfall":"五分钟雨量",
  "mobileTenMinuteRainfall":"十分钟雨量",
  "mobileOneHourRainfall":"一小时雨量",
  "mobileDayRain":"日雨量",
  "mobileMonthRain":"月雨量",
  "mobileLoad":"正在加载中",
  "mobileValue":"数值",
  "mobileNoData":"没有符合条件的数据",
}



// WEBPACK FOOTER //
// ./src/lang/zh.js